/*
 * THE PHONE'S BOTTOM BAR AND ITS MORE SHEET (frame 1h; reality.txt [26]).
 *
 * The record sheet covers the app's tabs, so the thumb's bar carries the screen's
 * one yellow button: Next's top line's main control, the same one the card would
 * have drawn (record.next.yellow, decided once in nextModel). More holds every
 * other control of Next, each named with the line it belongs to, then Change
 * status….
 *
 * Two controls are answered where they are, not through ops.control: Review (the
 * waiting changes, with Approve and Dismiss) and Move the wake-up (a date).
 * NextList opens them inside the card; on the phone they open inside the sheet,
 * so a tap on "Review" in the bar or in More is never a dead button.
 *
 * Pure, so test/record-phone-model.test.js pins it without a browser.
 */

// The controls a surface answers in place (NextList handles the same two).
export const IN_PLACE = new Set(["review", "move_wakeup"]);

/**
 * { primary, items }
 *   primary   { line, control, inPlace } | null: the yellow, and whether it opens
 *             a view in the sheet rather than running
 *   items     [{ key, line, control, label, meta, inPlace }]: More's rows, in
 *             Next's order, the yellow left out
 */
export function phoneBar(next) {
  const lines = (next && next.lines) || [];
  const y = next && next.yellow;
  const yLine = y ? lines[y.line] : null;
  const yControl = yLine && yLine.controls ? yLine.controls[0] : null;
  const primary = yLine && yControl ? { line: yLine, control: yControl, inPlace: IN_PLACE.has(yControl.id) } : null;

  const items = [];
  lines.forEach((line, i) => {
    (line.controls || []).forEach((control, j) => {
      if (y && y.line === i && j === 0) return;
      // A Proposed control is shown for its words on the card and never offered
      // as a tap here: More is a list of things that happen.
      if (control.proposed) return;
      items.push({
        key: `${line.key}:${control.id}`,
        line,
        control,
        label: control.label,
        meta: line.title,
        inPlace: IN_PLACE.has(control.id),
      });
    });
  });
  return { primary, items };
}

/** The line a sheet view belongs to, read again from the reloaded model (it may be gone). */
export function lineByKey(next, key) {
  return ((next && next.lines) || []).find((l) => l.key === key) || null;
}
